import { InjectionToken, Provider } from '@angular/core';

export const ApiBaseUrl = new InjectionToken<string>('The base url of the api');

export const provideApiBaseUrlTesting = (
  url = 'http://localhost'
): Provider => ({
  provide: ApiBaseUrl,
  useValue: url,
});

export type SelectOptions = SelectOption[];
export type SelectOption = { label: string; value: number | string };
